'use client'

import { FC, memo } from 'react'

import { TitleComponent } from '@/app/shared/ui/title'

// interface
interface ISignUpLessonModal {
  title?: string
  content?: string
}

// component
const ContentComponent: FC<Readonly<ISignUpLessonModal>> = ({ title, content }) => {
  // return

  return (
    <div className={'-mt-5 overflow-visible max-tablet:-mt-0'}>
      <TitleComponent
        classSize={'text-[28px] extraMobile:text-[34px]'}
        className={
          'max-w mb-[30px] w-[90%] text-[22px] extraMobile:text-[26px] [&:first-letter]:uppercase'
        }
      >
        {title}
      </TitleComponent>
      {content && (
        <div className='flex items-center justify-center'>
          <span className='text-2xl'>{content}</span>
        </div>
      )}
    </div>
  )
}

ContentComponent.displayName = 'ContentComponent'

export default memo(ContentComponent)
